import { useMutation, useQueryClient } from "@tanstack/react-query";
import { API } from "../api-map";
import type { User } from "@/types/user";

interface NewUserData {
  email: string;
  name: string;
  programs: string[];
  isLegacyCHPUser: boolean;
}

const addNewUser = async (userData: NewUserData): Promise<User> => {
  const response = await fetch(API.USER_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(userData),
  });

  if (!response.ok) {
    throw new Error("Failed to add new user");
  }

  return response.json();
};

export const useAddNewUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addNewUser,
    onSuccess: (newUser) => {
      // Invalidate and refetch user data queries
      queryClient.invalidateQueries({ queryKey: ["userData"] });
    },
  });
};
